import { jsx as _jsx } from "react/jsx-runtime";
import { useVisibleAttributeValues } from "../../AttributeValue";
import { ValuesGrid } from "../Common/ValuesGrid";
import { ThumbnailItem } from "./ThumbnailItem";
/**
 * Thumbnail control
 * @category UI
 * @param props
 * @returns
 */
export function ThumbnailControl(props) {
    const values = useVisibleAttributeValues();
    return (_jsx(ValuesGrid, { defaultEnabled: true, values: values, ValueDisplayComponent: ThumbnailItem, children: props.children }));
}
//# sourceMappingURL=ThumbnailControl.js.map